import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface BirthDateFieldModel extends BaseFieldModel {
  defaultValue: string | undefined;
  placeholder: CultureTextModel[] | string;
  type: FieldType.Birthdate;
}
export class BirthDateField extends BaseField implements BirthDateFieldModel {
  public defaultValue: string | undefined;
  public placeholder: CultureTextModel[] | string = '';
  public type: FieldType.Birthdate = FieldType.Birthdate;

  constructor(cultures: string[]) {
    super(FieldType.Birthdate, cultures);

    this.placeholder = [];
    for (const culture of cultures) {
      this.placeholder.push({ culture, value: '' });
    }
  }
}
